import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { FileType } from '../../FileUploadManagement/constants/FileUploadConstants';
import { CSV_UPLOAD_ENDPOINTS } from '../constants/endpoints';
import { convertExcelToCSV, isExcelFile } from '../utils/excelToCSV';

const {
    TYPE_OF_PURCHASE,
    ADVERTISERS,
    CATEGORIES,
    ACCOUNT_EXECUTIVES,
    CONTEXTUAL,
    NON_CONTEXTUAL,
} = CSV_UPLOAD_ENDPOINTS;

const {
    AE,
    ADVERTISERS: ADVERTISERS_UPLOAD,
    CATEGORY,
    TYPE_OF_PURCHASE: TYPE_OF_PURCHASE_UPLOAD,
    CONTEXTUAL_INVENTORY,
    NON_CONTEXTUAL_INVENTORY,
} = FileType;

// Dynamic mutation key and endpoint based on type
const getCsvUploadEndpointFromFileType = (fileType: string) => {
    switch (fileType) {
        case TYPE_OF_PURCHASE_UPLOAD:
            return TYPE_OF_PURCHASE;
        case AE:
            return ACCOUNT_EXECUTIVES;
        case CATEGORY:
            return CATEGORIES;
        case ADVERTISERS_UPLOAD:
            return ADVERTISERS;
        case CONTEXTUAL_INVENTORY:
            return CONTEXTUAL;
        case NON_CONTEXTUAL_INVENTORY:
            return NON_CONTEXTUAL;
    }
};

// Service functions should receive the artEventId as a parameter
export const uploadCSV = async (
    api: ApiClient,
    file: File,
    fileType: string,
    artEventId?: string
) => {
    let endpoint = getCsvUploadEndpointFromFileType(fileType);

    // Appending artEventId for CONTEXTUAL and NON_CONTEXTUAL API's
    if (
        fileType === CONTEXTUAL_INVENTORY ||
        fileType === NON_CONTEXTUAL_INVENTORY
    ) {
        if (!artEventId) {
            throw new Error(
                'artEventId is required for Contextual/Non-Contextual file type'
            );
        }
        endpoint = `${endpoint}${encodeURIComponent(artEventId)}`;
    }

    if (endpoint) {
        // Convert Excel files to CSV before uploading
        let fileToUpload = file;
        if (isExcelFile(file)) {
            fileToUpload = await convertExcelToCSV(file);
        }

        const data = new FormData();
        data.append('file', fileToUpload);
        return api.post(`${endpoint}`, data);
    }
};
